import { cn } from '../../lib/cn';
import type { TenantOpRow } from '../../enterpriseacceptance/framework';

type Props = { tenantName?: string; operations?: TenantOpRow[] };

export function InternalTenantPanel({ tenantName = 'Nakabh', operations = [] }: Props) {
  return (
    <div>
      <div className="mb-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 dark:border-amber-900 dark:bg-amber-950">
        <p className="text-sm font-semibold text-amber-800 dark:text-amber-200">Internal Tenant: {tenantName}</p>
        <p className="text-xs text-amber-700 dark:text-amber-300">All daily business processes executed exclusively through the platform</p>
      </div>
      <div className="space-y-2">
        {operations.map((o) => (
          <div key={o.process} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
            <div>
              <p className="text-sm font-medium">{o.process}</p>
              <p className="text-xs text-slate-500">{o.lastRun}</p>
            </div>
            <span className={cn(
              'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
              o.status === 'completed' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
              'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
            )}>
              {o.status.replace('_', ' ')}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
